import { render, staticRenderFns } from "./SaplingGeneRepresentation.vue?vue&type=template&id=2b49fbe0&scoped=true"
import script from "./SaplingGeneRepresentation.vue?vue&type=script&lang=ts"
export * from "./SaplingGeneRepresentation.vue?vue&type=script&lang=ts"
import style0 from "./SaplingGeneRepresentation.vue?vue&type=style&index=0&id=2b49fbe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49fbe0",
  null
  
)

export default component.exports